import React, { useRef, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import clsx from 'clsx';

import { usePopupPosition } from '../../hooks';

type PopupProps = {
  trigger: React.ReactNode;
  children: React.ReactNode;

  className?: string;
  popupClassName?: string;
  wrapperClassName?: string;
};

const Popup: React.FC<PopupProps> = ({
  trigger,
  children,
  className,
  popupClassName,
  wrapperClassName,
}) => {
  const [open, setOpen] = useState(false);
  const refAnchorRef = useRef<any>(null);

  const {
    popupRef,
    anchorRef,

    popupPosition,
    anchorPosition,
  } = usePopupPosition();

  const handleToggle = () => setOpen(o => !o);
  const handleClose = () => setOpen(false);

  useOnClickOutside(refAnchorRef, handleClose);

  return (
    <>
      <div
        ref={node => {
          node && anchorRef(node);
          refAnchorRef.current = node;
        }}
        className={clsx('relative', className)}
      >
        <div
          onClick={handleToggle}
          className={clsx(wrapperClassName, 'cursor-pointer')}
        >
          {trigger}
        </div>
        <div
          ref={popupRef}
          style={{
            left: popupPosition?.style?.left ?? 0,
            top: popupPosition?.style?.top ?? 0,
            minWidth: anchorPosition.width ?? 0,
            maxWidth: 300,
          }}
          className={clsx(
            'fixed z-popper py-sm',
            open ? 'visible' : 'invisible'
          )}
        >
          <div
            className={clsx(
              popupClassName,
              'shadow-sm border bg-content border-active',
              'transition-non-position',
              open ? 'opacity-100' : 'opacity-0'
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(Popup) as typeof Popup;
